import { Outlet } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import { LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";

export function OnboardingLayout() {
  return (
    <TooltipProvider>
      <div className="flex h-screen bg-background">
        <div className="flex-1 overflow-hidden">
          <div className="flex flex-col h-full">
            <main className="flex-1 overflow-auto">
              <div className="container mx-auto py-4">
                <div
                  className="absolute flex items-center"
                  style={{
                    top: "16px",
                    zIndex: 100,
                    left: "20px",
                  }}
                >
                  <img src="/logo.png" alt="Creator Logo" className="h-12" />
                </div>
                <Outlet />
              </div>
            </main>
            <div className="fixed bottom-4 right-4">
              <Button
                variant="outline"
                size="sm"
                className="text-muted-foreground hover:text-primary flex items-center gap-2 shadow-sm"
                onClick={() =>
                  window.open("https://cal.com/aicreator/30min", "_blank")
                }
              >
                <LifeBuoy className="h-4 w-4" />
                <span>Need help? Schedule a call</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </TooltipProvider>
  );
}
